<template>
    <div v-if="! isFilesFetching">
        <div
            v-if="! files.data.length"
            class="box-body with-border clearfix"
        >
            <p>There are no Source Number Files for this Api.</p>
        </div>
        <div v-else>
            <div
                v-if="files.total"
                class="box-body with-border clearfix"
            >
                <BadgeTotal
                    :value="files.total"
                    color="gray"
                    label="Total: "
                ></BadgeTotal>
            </div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Filename</th>
                        <th>Rows Parsed</th>
                        <th>Source Numbers</th>
                        <th v-if="withApis">Api</th>
                        <th class="text-center">Status</th>
                        <th class="text-right">Created At</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="file in files.data"
                        :key="file.id"
                    >
                        <td>{{ file.id }}</td>
                        <td>{{ file.name }}</td>
                        <td>
                            <span v-if="file.stored_path">
                                {{ file.original_name }}
                            </span>
                            <em v-else class="text-info">Lost</em>
                        </td>
                        <td>
                            <BadgeTotal
                                :value="file.rows_parsed"
                                color="gray"
                            />
                        </td>
                        <td>
                            <BadgeTotal
                                :value="file.source_numbers_count"
                                color="gray"
                                title="Total"
                            />
                            <BadgeTotal
                                :value="file.source_numbers_ready_count"
                                color="green"
                                title="Ready"
                            />
                            <BadgeTotal
                                :value="file.source_numbers_released_count"
                                color="red"
                                title="Released"
                            />
                        </td>
                        <td v-if="withApis">
                            <a :href="getRoute(file.api.id, 'apiShow')">
                                <span
                                    :class="ifActive(file.api.active, 'text-red')"
                                    :title="ifActive(file.api.active, 'Disabled')"
                                >
                                    {{ file.api.name }}
                                </span>
                            </a>
                        </td>
                        <td class="text-center">
                            <span :class="'label bg-'+ file.status_color">
                                {{ file.status_formatted }}
                            </span>
                        </td>
                        <td class="text-right">
                            {{ file.created_at }}
                        </td>
                        <td class="text-right">
                            <ModalContent
                                v-if="isUseGroup && file.is_releasable"
                                :id="file.id"
                                :route="route"
                                type="releaseFiles"
                                @click="isShowModal = true"
                                @modalEmitData="emittedModalData"
                            />
                            <a
                                :href="getRoute(file.id, 'edit')"
                                class="btn btn-sm btn-primary"
                            >
                                <i class="fa fa-edit"></i>
                                <span class="sr-only">Edit</span>
                            </a>
                            <a
                                :href="getRoute(file.id, 'show')"
                                class="btn btn-sm btn-info"
                            >
                                <i class="fa fa-eye"></i>
                                <span class="sr-only">Show</span>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div
                class="box-footer clearfix"
                @click="preventEnter"
                @keydown="preventEnter"
            >
                <pagination
                    :class="isDisabled()"
                    :data="files"
                    :limit="$root.paginator.settings.limit"
                    :size="$root.paginator.settings.size"
                    class="pull-right no-margin vue-pagination"
                    show-disabled
                    @pagination-change-page="getData"
                >
                    <span slot="prev-nav">
                        <i class="fa fa-angle-double-left"></i>
                    </span>
                    <span slot="next-nav">
                        <i class="fa fa-angle-double-right"></i>
                    </span>
                </pagination>
            </div>
            <main-modal-form
                v-if="isShowModal"
                :modal="emittedModalValues"
                @close="isShowModal = false"
                @updateData="modalData($event)"
            />
        </div>
    </div>
    <!-- /.box-body -->

</template>

<script>
import BadgeTotal from '../../subcomponents/BadgeTotal';
import ModalContent from '../../subcomponents/modals-content/ModalApisContent';

export default {
    data() {
        return {
            files: {},
            disablePagination: true,
            isFilesFetching: true,
            pageNumber: this.$route.query.pageFiles,
            isShowModal: false,
            emittedModalValues: {},
            route: {
                'apiShow': '/apis/:id:',
                'releaseFiles': '/asn/files/:id:/release-vue',
                'show': '/asn/files/:id:',
                'edit': '/asn/files/:id:/edit'
            }
        }
    },
    props: {
        'apiId': Number,
        'isUseGroup': {
            type: Boolean,
            default: false,
        },
        'withApis': {
            type: Boolean,
            default: false,
        }
    },
    mounted() {
        this.getData(this.pageNumber);
    },
    methods: {
        emittedModalData: function (value) {
            this.emittedModalValues = value
        },
        modalData: function (e) {
            this.isShowModal = false
            _.merge(_.keyBy(this.files.data, 'id'), _.keyBy({0: e}, 'id'));
        },
        preventEnter: function (event) {
            if (this.disablePagination) {
                return event.preventDefault();
            }
        },
        getData(page = 1) {
            this.disablePagination = true;

            axios
                .get(`/apis/${this.apiId}/data-files?page=${page}`)
                .then((response) => {
                    if (String(page) !== String(this.$route.query.pageFiles)) {
                        this.$router.push({ query: Object.assign({}, this.$route.query, { pageFiles: String(page) }) });
                    }

                    if (page > response.data.files.last_page) {
                        return this.getData();
                    }

                    this.files = response.data.files;
                    this.isFilesFetching = false;
                    this.disablePagination = false;
                });
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        ifActive: function (value, text) {
            return value ? '' : text;
        },
        isDisabled: function () {
            return this.disablePagination ? 'disabled-box' : '';
        },
    },
    components: {
        BadgeTotal,
        ModalContent,
    },
}
</script>
